import { useContext, useState} from "react";
import { Helmet } from "react-helmet-async";
import { RecruiterHeader } from "../components/Shared/RecruiterHeader";
import { StyleContext } from "../providers/StyleContextProvider";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as HeaderMobile } from "../assets/svg/short-building.svg";
import { ReactComponent as HeaderDesktop } from "../assets/svg/long-bulding.svg";
import { Footer } from "../components/Shared/Footer";
import { Button } from "../components/Shared/Buttons/Button";
import { GetInTouch } from "../components/Shared/GetInTouch";
import { ResponseModel } from "../models/ResponseModel";
import useErrorPage from "../hooks/useErrorPage";
import { useSearchParams } from "react-router-dom";
import { unsubscribeEmail } from "../services/RecruiterService";

export const RecruiterEmailUnsubscribePage: React.FC = () => {
    const styleContext = useContext(StyleContext);
    const [searchParams] = useSearchParams();
    const styles = styleContext.getComponentStyle("recruiterEmailUnsubscribePage");
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const referenceId: string = searchParams.get("referenceId") ?? "";
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();

    async function unsubscribeRecruiterEmail () {
        setLoading(true);
        await unsubscribeEmail(referenceId)
        .then((response: ResponseModel) => {
            setMessage(response.message);
            setIsSuccess(response.status);
            setIsSubmitted(true);
        })
        .catch((error) => {            
            toErrorPage(error);
        })
        .finally(() => {
            setLoading(false);
        });
    }

    return (
        <> 
            <Helmet><title>Email Unsubscribe - Xpressjobs</title></Helmet>
            <RecruiterHeader recruiterLoginEnable={true} isBackButtonHidden={true} />
            <div style={styles.header}>
                {isMobile ? <HeaderMobile style={styles.header.backgroundSvg}/> : <HeaderDesktop style={styles.header.backgroundSvg}/>}
                <div style={styles.header.heading}>Unsubscribe from Mailing List</div>
            </div>
            <div style={styles.content}>
                {!isSubmitted
                    ? <Button style={styles.button} onClick={unsubscribeRecruiterEmail} disabled={loading}>UNSUBSCRIBE</Button> 
                    : <div style={isSuccess ? styles.messageSuccess : styles.messageWarning}>{message}</div>
                }
            </div>
            <GetInTouch/>
            <Footer/>
        </>
    )
}